import { Panel } from "primereact/panel"
import React, { Fragment, useEffect, useState } from "react"
import IconInputText from "../../component/iconInputText/iconInputText"
import { LabelHeading } from "../../component/LabelHeader/labelHeader.style"
import SelectButtonComp from "../../component/SelectButton/selectButtonComp"
import { Container, TableHeader, UnderlineGlobalValue } from "../global/global.style"
import FilterImage from "../../assests/funnelFilterImage.svg"
import ResetImage from "../../assests/resetImage.svg"
import { theme } from "../../theme/theme"
import { Button } from "primereact/button"
import TableComponent from "../../component/Tables/tableComponent"
import { useDispatch, useSelector } from "react-redux"
import { InputSwitch } from 'primereact/inputswitch';
import { ToggleButton } from "primereact/togglebutton"
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from "primereact/progressspinner"
import {  getDQRuleHistory, getDQAssetRuleHistory } from "../../redux/dataAsset/dataAsset.action";

function DqRuleHistory({dataAssetId}) {
    const dispatch =useDispatch()
    const { apiData, formData } = useSelector((state) => state.dataAsset)
    const [currentDisplayButton, setCurrentDisplayButton] = useState("Last Week")
    const [ruleType, setRuleType] = useState("Column Level Rules")
    const [searchVal, setSearchVal] = useState("")
    const [enableRecommendation, setEnableRecommendation] = useState(false)
    const [checked, setChecked] = useState(false)
    const [pagination, setPagination] = useState({
        first: 0,   // index of the first record
        rows: 15,    // number of rows per page
    });


    // Handle page change
    const handlePageChange = (e) => {
        setPagination({
            first: e.first,   // new first record index
            rows: e.rows,     // new number of rows per page
        });
    };
    const templateType = (rowData, type, fieldType) => {
        switch (type) {
            case "text":
                return <span style={{ display: "block", overflowWrap: "anywhere" }}>{rowData[fieldType]}</span>

            case "description":
                return <span style={{ display: "block", overflowWrap: "anywhere", width: "100px" }}>{rowData[fieldType]}</span>

            case "boolean":
                return <span style={{ display: "block", overflowWrap: "anywhere", width: "60px" }}>{JSON.stringify(rowData[fieldType])}</span>

            default:
                return <span style={{ display: "block", overflowWrap: "anywhere", width: "100px" }}>{rowData[fieldType]}</span>

        }

    }

    const actionTemplete = () => {
        return <Fragment>
            <UnderlineGlobalValue>View</UnderlineGlobalValue>
        </Fragment>
    }

    const ruleOptions = [
        { label: 'All Rules', value: 'all' },
        { label: 'Active Rules', value: 'active' },
        { label: 'Inactive Rules', value: 'inactive' },
    ];

    const getTableColumns = () => {
        if (ruleType === "Column Level Rules") {
            return [
                { field: "column_name", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Column Name</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                { field: "rules_name", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Rule Name</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                 { field: "threshold_type", header: <TableHeader style={{ fontSize: "12px", width: "150px" }}>Threshold Type</TableHeader>, style: { width: "150px" } },
                 { field: "threshold_value", header: <TableHeader style={{ fontSize: "12px", width: "150px" }}>Threshold</TableHeader>, style: { width: "150px" } },
                 { field: "expression", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Expression</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                 { field: "modified_by", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Modified By</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                { field: "modified_date", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Modified Date</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                { field: "is_active", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Is Active</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                // { field: "is_active", header: "Is Active" },
            ]
        }
        else if (ruleType === "Asset Level Rules") {
                return [
                    { field: "dimension", header: <TableHeader style={{ fontSize: "12px", width: "200px" }}>Dimension</TableHeader>, style: { width: "200px", overflowWrap: "anywhere" } },
                    { field: "rules_name", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Rule Name</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                    { field: "drift_type", header: <TableHeader style={{ fontSize: "12px", width: "150px" }}>Drift Type</TableHeader>, style: { width: "150px" } },
                    { field: "driftValue", header: <TableHeader style={{ fontSize: "12px", width: "150px" }}>Drift Value</TableHeader>, style: { width: "150px" } },
                    { field: "expression", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Expression</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                    // { field: "rule_description", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Description</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                    // { field: "check_name", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>DQ Rule Check</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } }, 
                    { field: "modified_by", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Modified By</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },
                { field: "modified_date", header: <TableHeader style={{ fontSize: "12px", width: "250px" }}>Modified Date</TableHeader>, style: { width: "250px", overflowWrap: "anywhere" } },        
                    { field: "is_active", header: <TableHeader style={{ fontSize: "12px", width: "100px" }}>Is Active</TableHeader>, style: { width: "100px", overflowWrap: "anywhere" } },
                ]
            }

    }

    // const getTableColumns = () => {
    //     return [
    //         { field: "column_name", header: <TableHeader style={{ width: "100px", display: "inline-block" }}>Column Name</TableHeader>, style: { width: "100px",overflowWrap:"anywhere" }  },
    //         { field: "rules_name", header: <TableHeader style={{ width: "100px", display: "inline-block" }}>Rule Name</TableHeader>, style: { width: "100px",overflowWrap:"anywhere" }  },
    //         { field: "modified_by", header: <TableHeader style={{ width: "100px", display: "inline-block" }}>Modified By</TableHeader>,  style: { width: "100px",overflowWrap:"anywhere" }  },
    //         { field: "date_time", header: <TableHeader style={{ width: "100px", display: "inline-block" }}>Date</TableHeader>, style: { width: "100px",overflowWrap:"anywhere" } },
    //         { field: "is_active", header: <TableHeader style={{ width: "60px", display: "inline-block" }}>Is Active</TableHeader>, style: { width: "100px",overflowWrap:"anywhere" } },
    //     ]
    // }
    // const getTableData = () => {
    //     let tempValue = formData.dqRuleHistoryForm.options.filter((val) => val.is_active === checked)
    //     if (searchVal === "") {
    //         return tempValue
    //     } else {
    //         return tempValue.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase()))

    //     }
    // }
    const getTotalTableData = () => {
        let tempValue = []
        if (ruleType === "Column Level Rules") {

            if (searchVal === "") {
                tempValue = JSON.parse(JSON.stringify(formData.dqRuleHistoryForm.options))
            } else {
                tempValue = formData.dqRuleHistoryForm.options.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase()))

            }
        }
        else if (ruleType === "Asset Level Rules") {
            if (searchVal === "") {
                tempValue = JSON.parse(JSON.stringify(formData.dqRuleHistoryAssetForm.options))
            } else {
                tempValue = formData.dqRuleHistoryAssetForm.options.filter((val) => val.dimension.toLowerCase().includes(searchVal.toLowerCase()))


            }

        }
        return tempValue
    }

    const getTableData = () => {
        let tempValue = []
        if (ruleType === "Column Level Rules") {
            if (searchVal === "") {
                tempValue = formData.dqRuleHistoryForm.options.slice(pagination.first, pagination.first + pagination.rows)
            } else {
                tempValue = formData.dqRuleHistoryForm.options.filter((val) => val.column_name.toLowerCase().includes(searchVal.toLowerCase())).slice(pagination.first, pagination.first + pagination.rows)
            }
        } else if (ruleType === "Asset Level Rules") {
            if (searchVal === "") {
                tempValue = formData.dqRuleHistoryAssetForm.options.slice(pagination.first, pagination.first + pagination.rows)
            } else {
                tempValue = formData.dqRuleHistoryAssetForm.options.filter((val) => val.dimension.toLowerCase().includes(searchVal.toLowerCase())).slice(pagination.first, pagination.first + pagination.rows)
            }

        }
        return tempValue 
    }

     useEffect(() => {
          dispatch(getDQRuleHistory(dataAssetId))
          dispatch(getDQAssetRuleHistory(dataAssetId))
       }, [])

    return <Fragment>
        {apiData.dqRuleHistory.loading?<div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div>
                    :<Container style={{ height: "90%" }}>
        <div className="grid">
            <div className="col-12">
                <LabelHeading style={{
                }}>DQ Rules History</LabelHeading>
            </div>
            {/* <div className="col-6" style={{ display: "inherit", justifyContent: "end" }}>
                <div style={{ width: "300px", display: "inline-block", marginRight: "5px" }}>
                    <IconInputText iconPosition="left" style={{ width: "100%", marginRight: "10px", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search for Column" />
                </div>
                <Dropdown
                    defaultValue={'all'}
                    value={selectedRuleFilter}
                    options={ruleOptions}
                    onChange={handleChange}
                    placeholder="Filter Rule"
                    style={{marginRight:"5px"}}
                />
                
                <Button style={{ width: "43px", height: "40px" }} onClick={()=>{dispatch(getDQRuleHistory(dataAssetId))}}icon="pi pi-refresh" outlined />
            </div> */}
        </div>
        <div className="grid" style={{ marginTop: "5px", width: "100%" }}>
                           <div className="col-5" style={{ paddingBottom: "10px" }}>
                               <SelectButtonComp style={{ height: "20px" }} value={{ name: ruleType }} onChange={(e) => setRuleType(e.value.name)} optionLabel="name" options={[
                                   { name: "Asset Level Rules" },
                                   { name: "Column Level Rules" }
                                  
                               ]} />
                           </div>
                       </div>
        <Panel>
                    <div className="grid" >
                        <div className="col-4" style={{}}>
                            <IconInputText iconPosition="left" style={{ width: "85%", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search Columns" />
                        </div>
                        {/* <div className="col-1">
                        </div> */}
                        <div className="col-2" style={{ textAlign: "right" }}>
                        </div>
                         <div className="col-6" style={{ textAlign: "right" }}>
            
                        {/* <Dropdown
                            defaultValue={'all'}
                            value={selectedRuleFilter}
                            options={ruleOptions}
                            onChange={handleChange}
                            placeholder="Filter Rule"
                            style={{ marginRight: "5px" }}
                        /> */}
                        {/* <Button style={{ marginRight: "5px", width: "43px", height: "40px" }} icon="pi pi-filter" outlined /> */}
                        {/* <Button style={{ width: "43px", height: "40px" }} icon="pi pi-refresh" outlined onClick={()=>{dispatch(getDQRuleHistory(dataAssetId))}} /> */}
                        <Button style={{ width: "43px", height: "40px" }} icon="pi pi-refresh" outlined onClick={() => {
                                if (ruleType === "Column Level Rules") {
                                    dispatch(getDQRuleHistory(dataAssetId))
                                } else if (ruleType === "Asset Level Rules") {
                                    dispatch(getDQAssetRuleHistory(dataAssetId))
                                }
                            }} />
                    </div>
                    </div>
            <hr style={{
                margin: "0px",
                border: "0", /* Remove default border */
                height: "1px", /* Set the height of the line */
                backgroundColor: "#e3d8d8" /* Change the color */
            }} />
            <TableComponent
                paginator
                rows={pagination.rows}
                first={pagination.first}
                totalRecords={getTotalTableData().length}
                onPage={handlePageChange}  // Handle page change
                rowsPerPageOptions={[15, 30, 45]}  // Options to change rows per page
                virtualScroll  // Use virtual scrolling
                lazy           // Enable lazy loading
                className="p-datatable-sm"
                checked={false}
                tableData={getTableData()}
                columns={getTableColumns()} />

        </Panel>

    </Container>}
    </Fragment>
}

export default DqRuleHistory